export enum CONSTANTS {
    GUEST_ID_HEADER_NAME = 'x-guest-id',
}
